(() => {
  const root = document.querySelector('[data-product-section]');
  if (!root) return;
  const form = root.querySelector('[data-product-form]');
  const submit = form?.querySelector('.pp-add-to-cart');
  const sticky = root.querySelector('[data-sticky-atc]');
  const stickySubmit = root.querySelector('[data-sticky-submit]');
  const error = root.querySelector('[data-product-error]');
  const variants = JSON.parse(root.querySelector('[data-variants]')?.textContent || '[]');
  const rootPath = window.Shopify?.routes?.root || '/';
  let busy = false;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'it', {style:'currency', currency:root.dataset.currency || 'EUR'}).format(cents / 100);
  const selectedVariant = () => {
    const choices = [...form.querySelectorAll('.pp-option-group')].map(group => group.querySelector('input:checked')?.value);
    return choices.length ? variants.find(v => choices.every((value,i) => v.options[i] === value)) : variants.find(v => String(v.id) === form.querySelector('[data-variant-id]').value);
  };
  function updateVariant() {
    const variant = selectedVariant();
    const id = form.querySelector('[data-variant-id]');
    id.value = variant?.id || '';
    submit.disabled = busy || !variant?.available;
    stickySubmit.disabled = submit.disabled;
    submit.querySelector('span:last-child').textContent = variant?.available ? 'Aggiungi al carrello' : 'Non disponibile';
    const price = root.querySelector('[data-product-price]');
    price.replaceChildren();
    const stickyPrice = sticky.querySelector('div > span'); if (stickyPrice) stickyPrice.textContent = variant ? money(variant.price) : '';
    if (variant) {
      if (variant.compare_at_price > variant.price) { const s = document.createElement('s'); s.textContent = money(variant.compare_at_price); price.append(s); }
      const strong = document.createElement('strong'); strong.textContent = money(variant.price); price.append(strong);
      const stickyPrice = sticky.querySelector('div > span'); if (stickyPrice) stickyPrice.textContent = money(variant.price);
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    }
  }
  root.querySelectorAll('.pp-option-group input').forEach(input => input.addEventListener('change', updateVariant));
  if (form && submit) updateVariant();
  // Gallery navigation is handled by pdp-gallery-fix.js so clicks never scroll the page itself.
  root.querySelectorAll('[data-countable]').forEach(input => input.addEventListener('input', () => {
    const counter = input.closest('.pp-field')?.querySelector('[data-count]'); if (counter) counter.textContent = input.value.length;
  }));
  root.querySelector('[data-file-input]')?.addEventListener('change', event => {root.querySelector('[data-file-name]').textContent = event.target.files?.[0]?.name || 'Nessun file selezionato';});
  root.querySelectorAll('[data-qty]').forEach(qty => {
    const input = qty.querySelector('input');
    qty.querySelector('[data-qty-minus]').addEventListener('click', () => input.value = Math.max(1, Number(input.value || 1) - 1));
    qty.querySelector('[data-qty-plus]').addEventListener('click', () => input.value = Math.max(1, Number(input.value || 1) + 1));
  });
  stickySubmit?.addEventListener('click', () => { if (!submit.disabled) form.requestSubmit(submit); });
  form?.addEventListener('submit', async event => {
    if (!window.fetch) return;
    event.preventDefault();
    if (busy || !selectedVariant()?.available) return;
    busy = true; submit.disabled = true; stickySubmit.disabled = true; error.hidden = true;
    submit.querySelector('span:last-child').textContent = 'Sto aggiungendo…';
    try {
      const response = await fetch(rootPath + 'cart/add.js', {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      if (!response.ok) { const result = await response.json(); throw new Error(result.description || 'Non è stato possibile aggiungere il prodotto.'); }
      document.dispatchEvent(new CustomEvent('pp:cart-added'));
    } catch (e) {
      error.textContent = e.message === 'Failed to fetch' ? 'Connessione interrotta. Controlla il carrello prima di riprovare.' : e.message;
      error.hidden = false;
    } finally { busy = false; updateVariant(); }
  });
  if (sticky && submit && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0)).observe(submit);
  }
})();
